import { KrpanoEngine } from 'utils/KrpanoEngine'

/**
 * AnnotationClickHandler
 * Domain handler responsible for triggering click actions on annotations in Krpano.
 * Simulates or delegates the click to Krpano's hotspot or window.handle_click_annotation.
 */
export class AnnotationClickHandler {
  public static clickAnnotation(annotationId: string | number): boolean {
    if (!annotationId) return false
    const annoIdStr = String(annotationId)

    // 1. Try to invoke Krpano hotspot onclick directly
    try {
      const krpano =
        new KrpanoEngine('full').instance ||
        new KrpanoEngine('viewer').instance ||
        (window as any).krpano ||
        (document.getElementById('embedpano-full') as any)

      if (krpano && typeof krpano.get === 'function') {
        const hs = krpano.get(`hotspot[id-${annoIdStr}]`)
        if (hs) {
          krpano.call(`callwith(hotspot[id-${annoIdStr}], onclick);`)
          return true
        }
      }
    } catch {
      // Krpano instance call failed or not yet mounted
    }

    // 2. Try window.handle_click_annotation (registered by useKrpano / useViewerKrpano)
    if (typeof (window as any).handle_click_annotation === 'function') {
      try {
        ;(window as any).handle_click_annotation(annoIdStr)
        return true
      } catch {
        // Ignore handler error
      }
    }

    return false
  }
}

export default AnnotationClickHandler
